'use client';

import React, { useEffect, useRef } from 'react';

interface ScrollPlayVideoProps {
  publicId: string;
  cloudName: string;
  className?: string;
}

export function ScrollPlayVideo({ publicId, cloudName, className = '' }: ScrollPlayVideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play().catch((err) => {
              // Ignore AbortError which occurs if pause is called before play completes
              if (err.name !== 'AbortError') {
                console.error('Error attempting to play video:', err);
              }
            });
          } else {
            video.pause();
          }
        });
      },
      {
        threshold: 0.1, // Trigger play/pause when 10% of the element is visible
      }
    );

    observer.observe(video);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className={`w-full aspect-video rounded-sm border border-gray-200 bg-gray-50/60 overflow-hidden shadow-sm ${className}`}>
      <video
        ref={videoRef}
        src={`https://res.cloudinary.com/${cloudName}/video/upload/f_auto,q_auto/${publicId}.mp4`}
        className="w-full h-full object-cover"
        controls
        loop
        muted
        playsInline
        preload="metadata"
      />
    </div>
  );
}
